/**
 * Next workshop banner visibility and details.
 * Set showNextWorkshopBanner to true when you have a date and update
 * home.workshopDate, workshopTime, workshopLocation in i18n and the
 * URLs below (or in Home.js) as needed.
 *
 * showWho / showWhen: set to false to hide those items from the nav (pages still exist at /who and /when).
 */
export const WORKSHOP_CONFIG = {
  showNextWorkshopBanner: false,
  showWho: false,
  showWhen: false,
  // When true, optionally override URLs here or keep using i18n + Home.js:
  // registrationFormUrl: "https://...",
  // eventUrl: "https://...",
};
